import * as React from "react";
import { EBuyOrSell } from "../../../types/genericTypes";
import EdButton from "../../../generic/edButton";
import "../../../../assets/scss/components/toc/orderPlacement/opConfirmation/opConfirmation.scss";

export interface IOpConfirmationProps {
	buyOrSell: EBuyOrSell;
	title: string;
	subtitle: string;
	isSubtitlebig?: boolean;
	exchange?: "NSE" | "BSE"; // optional, will not show if not present
	contentArr: Array<IConfirmationContent>; // the array of field value data to show in the middle
	note?: React.ReactNode;
	onCancel: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	onConfirm: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export interface IConfirmationContent {
	field: string;
	value: string;
}

const OpConfirmation: React.FC<IOpConfirmationProps> = props => {
	return (
		<section className="op_confirmation">
			<div className="top_cont">
				<div className="buy_sell_tag_cont">
					<span className={"buy_sell_tag " + (props.buyOrSell === EBuyOrSell.BUY ? "green" : "red")}>{props.buyOrSell}</span>
				</div>

				<h1 className="title">
					{props.title} {props.exchange && <span className="exchange">{props.exchange}</span>}
				</h1>

				<h2 className={props.isSubtitlebig ? "title" : "subtitle"}>{props.subtitle}</h2>

				<div className="content">
					{props.contentArr.map(a => (
						<div className="row" key={a.field}>
							<span className="field">{a.field}</span>
							<span className="value">{a.value}</span>
						</div>
					))}
				</div>
			</div>

			{props.note && <div className="note">{props.note}</div>}

			<div className="buttons">
				<EdButton btnTyp="secondary" value="Cancel" onClick={props.onCancel} className="cancel_btn" />
				<EdButton btnTyp="primary" value="Confirm Order" onClick={props.onConfirm} className="confirm_btn" />
			</div>
		</section>
	);
};

export default OpConfirmation;
